<div class="flex flex-col gap-3">
    <div class="w-full p-3 font-medium text-md text-white bg-gray-400">
        {{_form.controls.name.value}}
    </div>
    <div class="flex flex-col gap-3">
        <app-regular-exercise-config-row [configForm]="config" [exerciseForm]="_form" *ngFor="let config of _form.controls.configs.controls"></app-regular-exercise-config-row>
    </div>
</div>
